import { Link } from 'react-router-dom';

function AttentionGlyph({ tone }) {
  if (tone === 'danger') {
    return (
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="8" />
        <path d="M12 8v5" strokeLinecap="round" />
        <circle cx="12" cy="16.2" r="0.9" fill="currentColor" stroke="none" />
      </svg>
    );
  }
  if (tone === 'warning') {
    return (
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="8" />
        <path d="M12 8v4.5" strokeLinecap="round" />
        <path d="M8.5 12h7" strokeLinecap="round" />
      </svg>
    );
  }
  if (tone === 'success') {
    return (
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="8" />
        <path d="M8.5 12.2l2.2 2.2 4.8-5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="8" />
      <path d="M12 11v5" strokeLinecap="round" />
      <circle cx="12" cy="8.2" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function AttentionItem({ tone = 'info', title, detail, to, action, onClick }) {
  const body = (
    <>
      <span className={`attention-icon attention-icon--${tone}`} aria-hidden>
        <AttentionGlyph tone={tone} />
      </span>
      <span className="attention-copy">
        <strong>{title}</strong>
        {detail ? <span className="muted small">{detail}</span> : null}
      </span>
      {action ? <span className="attention-action">{action}</span> : null}
    </>
  );

  if (to) {
    return (
      <Link to={to} className="attention-item">
        {body}
      </Link>
    );
  }

  if (onClick) {
    return (
      <button type="button" className="attention-item attention-item--button" onClick={onClick}>
        {body}
      </button>
    );
  }

  return <div className="attention-item">{body}</div>;
}
